import { render } from "./Notifications.vue?vue&type=template&id=58900127"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=58900127&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NotificationPlugin/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58900127"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58900127', __exports__)) {
    api.reload('58900127', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=58900127", () => {
    api.rerender('58900127', render)
  })

}


export default __exports__